import React from 'react';
import { connect } from 'react-redux';
import { List, Map } from 'immutable';
import Draggable from 'react-draggable';
import {
  allCheckStateDispatch,
  clearPositionBookReport,
  generateReport,
  selectProduct,
  updateCheckStateDispatch,
  updateFobPort,
  updateProductTypes,
} from './store/PositionBook.store';
import { getProductListWrapper } from '@/component/dict/complex/product/ProductWrapper.js';
import {
  avg,
  avgPriceQuantity,
  isAvoidReportReset,
  locationFallThroughInitial,
  MainComponentBox,
  navTo,
  productGroups,
  productNameResolver,
  formatPositionBookGroupName,
  formatGroupedProductAvgQ
} from '@/util/util.jsx';
import { Col, ControlLabel, Modal, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { updateDealMarketPrice } from '../deals/store/deal.store';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { getSimpleListWrapper } from '@/component/dict/simple/SimpleWrapper';
import RefPicker from '@/component/dict/simple/select/DictPicker.jsx';
import { numberSort, sortSimpleText } from '../deals/payments/PaymentsSort';
import FancyInput from '@/component/form/numinput/index.jsx';
import momentLocalizer from 'react-widgets-moment';
import { formatCurrency, formatNumber, formatRange } from '../deals/elements/BaseElement';
import { Button, Checkbox } from '../../form/FormControls.jsx';
import { getCurrencyValue } from '../deals/expenses/ExpensesUtils.jsx';
import { ReportName, userHasReportPermissions, validateRoleConfig }
  from '../../auth/RoleConfigFilter.jsx';
import { loadAllDeals } from '../deals/DealLoader';
import { Currency } from '@/consts/currency';
import moment from 'moment';
import './reports.less';
import { REF_NAME as BUYER_REF_NAME, REF_PATH as BUYER_REF_PATH }
  from '@/component/dict/simple/buyer/Const';
import { REF_NAME as SELLER_REF_NAME, REF_PATH as SELLER_REF_PATH }
  from '@/component/dict/simple/supplier/Const';
import { REF_NAME as PACKING_REF_NAME, REF_PATH as PACKING_REF_PATH }
  from '@/component/dict/simple/packing/Const';
import {
  REF_NAME as DELIVERY_TERM_REF_NAME,
  REF_PATH as DELIVERY_TERM_REF_PATH,
} from '@/component/dict/simple/deliveryterm/Const';
import { REF_NAME as PORT_REF_NAME, REF_PATH as PORT_REF_PATH }
  from '@/component/dict/simple/port/Const';
import xlsgrey from '../../../../style/xlsgrey.png';
import pdfgrey from '../../../../style/pdfgrey.png';
import pencil from '../../../../style/pencil.png';
import pencilred from '../../../../style/pencilred.png';

moment.locale('en');
momentLocalizer();

const columnWidths = {
  avgLS: '3%',
  sellerBuyer: '10%',
  contractNumber: '7%',
  product: '8%',
  packing: '6%',
  shipment: '8%',
  deliveryTerm: '4%',
  port: '10%',
  fobNetBack: '5%',
  origin: '7%',
  mts: '8%',
  priceDollar: '7%',
  colA: '6%',
  colB: '5%',
  colC: '6%',
};

// eslint-disable-next-line
const so = (v, order) => order == 'desc' ? v * -1 : v;

const groupDeals = (a, b) => {
  if (!(a.isTotalRow || b.isTotalRow)) {
    return sortSimpleText(a, b, 'asc', 'dealType');
  }
  return false;
};


const sortDate = (property, a, b, order) => {
  const v1 = a[property] && moment(a[property], 'DD MMM YYYY');
  const v2 = b[property] && moment(b[property], 'DD MMM YYYY');

  if (v1 == v2) {
    return 0;
  }
  if (v1) {
    if (v2) {
      return so(v2.isBefore(v1) ? -1 : 1, order);
    }
    return so(-1, order);
  }
  if (v2) {
    return so(1, order);
  }
  return so(v1.isBefore(v2) ? -1 : 1, order);
};

export const avgQuantity = p => avg(p.quantityMin, p.quantityMax);

export const unlinkedQuantity = (compositeProduct, unlinkedMin, unlinkedMax) => {
  if (unlinkedMin || unlinkedMax) {
    if (unlinkedMin == unlinkedMax) {
      return unlinkedMin;
    }
    return avg(unlinkedMin, unlinkedMax);
  }
  return avgQuantity(compositeProduct);
};

const dealSumSort = (a, b) => {
  const v1 = parseFloat(a.mtsMin ? a.mtsMin : 0);
  const v2 = parseFloat(b.mtsMin ? b.mtsMin : 0);
  if (v1 == v2) {
    return 0;
  }
  return v1 > v2 ? 1 : -1;
};

const contractDateSort = (a, b) => {
  const dateA = new Date(a.purchaseDate || a.saleDate || a.creationTime);
  const dateB = new Date(b.purchaseDate || b.saleDate || b.creationTime);
  return dateA < dateB ? 1 : -1;
};

const formatQuantityNumber = value => formatNumber(value, '0,0');

const totalQ = (...values) => {
  const result = values.reduce((sum, v) => isNaN(v) ? 'N/A'  // eslint-disable-line
    : (isNaN(sum) ? sum : sum + parseFloat(v)), 0);
  return isNaN(result) ? result : `${formatQuantityNumber(result)}`;
};

const addProductType = (ordered, productTypes, value) => {
  const v = productTypes.find(pt => pt.productType == value);
  if (v) {
    ordered.push(v);
  }
};


const getM2MDiff = (row) => {
  if (row.isTotalRow && row.totalM2MDelta) {
    return 0;
  }
  const marketPrice = parseFloat(row.marketPrice
    || (row.compositeProduct && row.compositeProduct.marketPrice) || row.externalM2M || 0);
  if (!marketPrice || !(row.priceValue || (row.compositeProduct
    && row.compositeProduct.priceValue))) {
    return 0;
  }
  const fixedPrice = row.compositeProduct ? row.compositeProduct.fixedPrice : row.fixedPrice;
  const price = row.fobNetBackOriginal
    || ((fixedPrice || fixedPrice === null) && (getCurrencyValue(row)
      || getCurrencyValue(row.compositeProduct || {})));
  if (row.dealType == 'sale') {
    return price - marketPrice;
  }
  return marketPrice - price;
};

const getM2MPL = (row) => getM2MDiff(row)
     * row.mtsNatural;


export const formatQuantityRangeNatural = (dto) => {
  const unlinkedMin = dto.unlinkedMin || dto.compositeProduct.quantityMin;
  const unlinkedMax = dto.unlinkedMax || dto.compositeProduct.quantityMax;
  if (unlinkedMin == unlinkedMax) {
    return unlinkedMin;
  }
  return avg(unlinkedMin, unlinkedMax);
};

const purchaseColumn = { color: 'var(--position-book-long)' };
const saleColumn = { color: 'var(--position-book-short)' };

const PRODUCT_CONFIG_MAP = {
  Urea: 'UREA',
  'A/N': 'AN',
  'A/S': 'AS',
  UAN: 'UAN',
  Phosphates: 'PHOSPHATES',
  Potash: 'POTASH',
  NPKs: 'NPKS',
  AGRI: 'AGRI',
  Sulfur: 'SULFUR',
  Solubles: 'SOLUBLES',
  Other: 'OTHER',
};

const thMainStyle = { textAlign: 'center', whiteSpace: 'normal' };

class PositionBook extends React.Component {
  constructor(props) {
    super(props);
    this.generateReport = this.generateReport.bind(this);
    this.expandComponent = this.expandComponent.bind(this);
    this.editProductHandler = this.editProductHandler.bind(this);
    this.updateDealMarkerPrice = this.updateDealMarkerPrice.bind(this);
    this.sortFunc = this.sortFunc.bind(this);
    this.showAlert = this.showAlert.bind(this);
    this.hideAccessDeniedAlert = this.hideAccessDeniedAlert.bind(this);
    this.childTables = [];
    this.state = { showAlert: false };
  }

  componentWillMount() {
    loadAllDeals();
    getSimpleListWrapper(BUYER_REF_NAME, BUYER_REF_PATH);
    getSimpleListWrapper(SELLER_REF_NAME, SELLER_REF_PATH);
    getSimpleListWrapper(PACKING_REF_NAME, PACKING_REF_PATH);
    getSimpleListWrapper(DELIVERY_TERM_REF_NAME, DELIVERY_TERM_REF_PATH);
    getSimpleListWrapper(PORT_REF_NAME, PORT_REF_PATH);
    getProductListWrapper();
    if (!isAvoidReportReset()) {
      this.props.clearPositionBook();
      this.generateReport();
    }
    locationFallThroughInitial('Position book', '/reports/positionbook');
  }

  // eslint-disable-next-line
  updateDealMarkerPrice(dealType, dealId, productId, marketPrice) {
    this.props.updateDealMarketPrice(dealType, dealId, productId, marketPrice);
  }

  renderAvgValuesArea() {
    const grouppedProducts = avgPriceQuantity(
      this.props.data.valueSeq().flatMap(list => list).filter(v => v.get('checkState')),
      (v) => v.get('unlinkedMin'), (v) => v.get('unlinkedMax'),
      (v) => v.get('overridenPrice'),
      (v) => v.get('dealType'),
      (v) => v.get('compositeProduct').toJS(),
      (v) => getM2MPL(v)
    );
    const grouppedKeys = Object.keys(grouppedProducts);
    if (!grouppedKeys.length) {
      return '';
    }
    return (
      <Draggable>
        <div className={'position-book-total-avg-area'}>
          <div>
            <Row style={{ fontWeight: 'bold' }}>
              <Col xs={4} className={'col position-book-total-avg-product'}>
                Product
              </Col>
              <Col xs={2} className={'col position-book-total-avg-qty'}>
                Long/Short
              </Col>
              <Col xs={2} className={'col position-book-total-avg-price'}>
                Price
              </Col>
              <Col xs={2} className={'col position-book-total-m2mpl'}>
                M2M P/L
              </Col>
              <Col xs={2} className={'col position-book-total-m2mpl'}>
                Avg Netback
              </Col>
            </Row>
            {grouppedKeys.map(key => {
              const data = grouppedProducts[key];
              return (
                <Row className={data.style}>
                  <Col xs={4} className={'col position-book-total-avg-product'}>
                    {formatPositionBookGroupName(data)}
                  </Col>
                  <Col xs={2} className={'col position-book-total-avg-qty'}>
                    {formatQuantityNumber(data.avgQ)}
                  </Col>
                  <Col xs={2} className={'col position-book-total-avg-price'}>
                    {`$ ${formatNumber(formatGroupedProductAvgQ(data), '0,0.[00]')}`}
                  </Col>
                  <Col
                    xs={2} className={`col position-book-total-m2mpl
                    ${data.m2mPL < 0 ? ' total-M2M-negative' : ''}
                    ${data.m2mPL > 0 ? ' total-M2M-positive' : ''}`}
                  >
                    {data.m2mPL && `$ ${formatNumber(data.m2mPL, '0,0')}`}
                  </Col>
                  <Col xs={2} className={'col position-book-total-avg-price'}>
                    ${formatNumber(data.fobNetback / data.groupSize, '0,0')}
                  </Col>
                </Row>
              );
            })}
          </div>
        </div>
      </Draggable>
    );
  }

  editProductHandler(type, productId) {
    this.props.selectProduct(type, productId);
  }

  productCheckbox(g) {
    const canEdit = validateRoleConfig(['management', 'viewReports'])
      || userHasReportPermissions([ReportName.POSITION_BOOK,
        ReportName.positionBook(PRODUCT_CONFIG_MAP[g])]);
    return (
      <div>
        <div
          className={'position-book-filter'}
          onClick={() =>
            canEdit && this.props.updateProductTypes(this.props.productTypes,
              g, !this.props.productTypes.includes(g))}
        >
          <Checkbox
            style={{ marginBottom: 0 }}
            disabled={!canEdit}
            checked={this.props.productTypes.some(pt => pt === g)}
          />
          <ControlLabel
            style={{ height: '100%' }}
          >
            {g}
          </ControlLabel>
        </div>
      </div>);
  }

  sortFunc(a, b, order, sortField) {
    const newSortField = sortField === 'label' ? 'sellerBuyer' : sortField;
    this.childTables.forEach((t) => {
      // eslint-disable-next-line
      t && t.getWrappedInstance().refs.table.handleSort(order, newSortField);
    });
    return 0;
  }

  headerClassName(value) {
    return value == 'FAKE' ? 'hidden' : 'position-book-product-row';
  }

  hideAccessDeniedAlert() {
    this.setState({ showAlert: false });
  }

  accessDeniedAlert(show) {
    return (
      <Modal bsSize="sm" show={show} onHide={this.hideAccessDeniedAlert}>
        <Modal.Body style={{ textAlign: 'center' }}>
          You have insufficient privileges for access
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.hideAccessDeniedAlert}>Ok</Button>
        </Modal.Footer>
      </Modal>);
  }

  hasChecked() {
    return this.props.data.valueSeq().some(list => list.filter(v => v.get('checkState')).size);
  }

  expandComponent(row) {
    const data = this.props.data.get(row.productType) || new List();
    return (
      <div>
        {this.props.done && <ProductGroupList
          ref={t => this.childTables.push(t)}
          data={data}
          totalData={row.total}
          editProduct={this.editProductHandler}
          disabled={this.props.saving}
          selectedProductId={this.props.selectedProductId}
          showAlert={this.showAlert}
          purchases={this.props.purchases}
          sales={this.props.sales}
          updateDealMarkerPrice={this.updateDealMarkerPrice}
          products={this.props.products}
        />
        }
      </div>);
  }

  showAlert() {
    this.setState({ showAlert: true });
  }

  generateReport() {
    this.props.generateReport();
  }

  positionBookTotal = (productTypes) => {
    const total = productTypes.flatMap(v => v.total);
    const overallM2MDeltaPurchase = total.filter(v => v.dealType === 'purchase')
      .reduce((t, v) => t + (v.totalM2MDelta || 0), 0);
    const overallM2MPLPurchase = total.filter(v => v.dealType === 'purchase')
      .reduce((t, v) => t + (v.totalM2MPL || 0), 0);

    const overallM2MDeltaSale = total.filter(v => v.dealType === 'sale')
      .reduce((t, v) => t + (v.totalM2MDelta || 0), 0);
    const overallM2MPLSale = total.filter(v => v.dealType === 'sale')
      .reduce((t, v) => t + (v.totalM2MPL || 0), 0);
    return [{
      shipment: 'ALL PRODUCTS M2M PURCHASE',
      diffM2M: overallM2MDeltaPurchase,
      M2MPL: overallM2MPLPurchase,
    },
    {
      shipment: 'ALL PRODUCTS M2M SALE',
      diffM2M: overallM2MDeltaSale,
      M2MPL: overallM2MPLSale,
    }];
  }

  currencyFormatter = (value) => `$ ${formatNumber(value, '0,0.00')}`

  m2mClassName = (value) => {
    const green = 'td-pb-actualPrice-green';
    const red = 'td-pb-actualPrice-red';
    if (value < 0) {
      return red;
    }
    if (value > 0) {
      return green;
    }
    return '';
  }

  getTotalM2MPL = (products) => products.reduce((sum, p) => sum + (getM2MPL(p) || 0), 0);
  getTotalM2MDiff = (products) => products.reduce((sum, p) => sum + (p.diffPrice || 0), 0);

  formatTotal(compositeProducts) {
    const purchaseProducts = compositeProducts.filter(p =>
      p.purchase || p.purchase === 0);
    const saleProducts = compositeProducts.filter(p =>
      p.sale || p.sale === 0);

    const purchasePriceProducts = purchaseProducts
      .filter(p => p.fixedPrice || p.fixedPrice === null);
    const salePriceProducts = saleProducts.filter(p => p.fixedPrice || p.fixedPrice === null);

    const purchaseQuantitySum = purchasePriceProducts
      .reduce((sum, p) => sum + unlinkedQuantity(p, p.unlinkedMin, p.unlinkedMax) || 0, 0);
    const saleQuantitySum = salePriceProducts
      .reduce((sum, p) => sum + unlinkedQuantity(p, p.unlinkedMin, p.unlinkedMax) || 0, 0);

    const purchasePriceSumQuantity = purchasePriceProducts.reduce((sum, p) => {
      const val = getCurrencyValue(p);
      return sum + (unlinkedQuantity(p, p.unlinkedMin, p.unlinkedMax) * val);
    }, 0);
    const salePriceSumQuantity = salePriceProducts.reduce((sum, p) =>
      sum + (unlinkedQuantity(p, p.unlinkedMin, p.unlinkedMax) * getCurrencyValue(p)), 0);


    const purchaseM2MPL = this.getTotalM2MPL(purchasePriceProducts);
    const purchaseM2MAvgDiff = this.getTotalM2MDiff(purchasePriceProducts);
    const saleM2MPL = this.getTotalM2MPL(salePriceProducts);
    const saleM2MAvgDiff = this.getTotalM2MDiff(salePriceProducts);

    const totalPricedPurchase = {
      isTotalRow: true,
      weight: 3,
      dealType: 'purchase',
      shipment: 'TOTAL PRICED',
      totalM2MDelta: purchaseM2MAvgDiff,
      totalM2MPL: purchaseM2MPL,
      mts: formatQuantityNumber(purchaseQuantitySum) || '-',
      priceDollar: purchaseQuantitySum ?
        `$ ${formatNumber(purchasePriceSumQuantity, '0,0')}` : '-',
    };

    const totalPricedSale = {
      isTotalRow: true,
      weight: 4,
      shipment: '',
      dealType: 'sale',
      totalM2MDelta: saleM2MAvgDiff,
      totalM2MPL: saleM2MPL,
      mts: formatQuantityNumber(saleQuantitySum) || '-',
      priceDollar: saleQuantitySum ?
        `$ ${formatNumber(salePriceSumQuantity, '0,0')}` : '-',
    };

    // has at least one formula
    if (compositeProducts.some(p => p.fixedPrice === false)) {
      const purchaseFormulaProducts = purchaseProducts.filter(p => p.fixedPrice === false);
      const saleFormulaProducts = saleProducts.filter(p => p.fixedPrice === false);

      const purchaseFormulaSumQuantity = purchaseFormulaProducts
        .reduce((sum, p) => sum + unlinkedQuantity(p, p.unlinkedMin, p.unlinkedMax) || 0, 0);
      const saleFormulaSumQuantity = saleFormulaProducts
        .reduce((sum, p) => sum + unlinkedQuantity(p, p.unlinkedMin, p.unlinkedMax) || 0, 0);

      const totalUnpricedPurchase = {
        isTotalRow: true,
        shipment: 'TOTAL UNPRICED',
        weight: 1,
        dealType: 'purchase',
        mts: formatQuantityNumber(purchaseFormulaSumQuantity) || '-',
        priceDollar: purchaseFormulaProducts.length ? 'Formula' : '-',
      };
      const totalUnpricedSale = {
        isTotalRow: true,
        shipment: '',
        weight: 2,
        dealType: 'sale',
        mts: formatQuantityNumber(saleFormulaSumQuantity) || '-',
        priceDollar: saleFormulaProducts.length ? 'Formula' : '-',
      };
      const grandTotalPurchase = {
        isTotalRow: true,
        isGrandTotalRow: true,
        weight: 5,
        shipment: 'GRAND TOTAL',
        dealType: 'purchase',
        mts: totalQ(purchaseFormulaSumQuantity, purchaseQuantitySum),
        priceDollar: purchaseFormulaProducts.length ? 'N/A' :
          `$ ${formatQuantityNumber(totalPricedPurchase.priceDollar)}`,
      };
      const grandTotalSale = {
        isTotalRow: true,
        isGrandTotalRow: true,
        weight: 6,
        shipment: '',
        dealType: 'sale',
        mts: totalQ(saleFormulaSumQuantity, saleQuantitySum),
        priceDollar: saleFormulaProducts.length ? 'N/A' :
          `$ ${formatQuantityNumber(totalPricedSale.priceDollar)}`,
      };
      return [totalUnpricedPurchase, totalUnpricedSale, totalPricedPurchase,
        totalPricedSale, grandTotalPurchase, grandTotalSale];
    }
    totalPricedPurchase.shipment = 'TOTAL';
    totalPricedPurchase.weight = 5;
    totalPricedSale.weight = 6;
    return [totalPricedPurchase, totalPricedSale];
  }

  render() {
    this.childTables = [];
    let productTypes = [];
    this.props.data.mapEntries(([k,]) => productTypes =                      // eslint-disable-line
      productTypes.concat([{
        productType: k,
        label: k.toUpperCase(),
        product: 0,
        packing: 0,
        shipment: 0,
        deliveryTerm: 0,
        port: 0,
        total: this.formatTotal(this.props.data.get(k).map(dto => {
          let result = dto.get('compositeProduct')
            .set('externalM2M', dto.get('externalM2M'))
            .set('fobNetBackOriginal', dto.get('fobNetBackOriginal'))
            .set('fobNetBack', dto.get('fobNetBack'))
            .set('dealType', dto.get('dealType'))
            .set('mtsNatural', formatQuantityRangeNatural(dto.toJS()))
            .set('unlinkedMin', dto.get('unlinkedMin'))
            .set('unlinkedMax', dto.get('unlinkedMax'))
            .set('diffPrice', getM2MDiff(dto.toJS()));
          const overridenPrice = dto.get('overridenPrice');
          if (overridenPrice || overridenPrice === 0) {
            result = result.set('priceValue', overridenPrice).set('priceCurrency', Currency.DOLLAR);
          }
          return result;
        }).toJS()),
      }]));
    productTypes = this.props.productTypes.size ?
      productTypes.filter(pt =>
        this.props.productTypes.some(p => pt.productType === p)) : productTypes;
    const ordered = [];
    addProductType(ordered, productTypes, 'Urea');
    addProductType(ordered, productTypes, 'UAN');
    addProductType(ordered, productTypes, 'A/N');
    addProductType(ordered, productTypes, 'A/S');
    addProductType(ordered, productTypes, 'Phosphates');
    addProductType(ordered, productTypes, 'Potash');
    addProductType(ordered, productTypes, 'NPKs');
    addProductType(ordered, productTypes, 'Solubles');
    addProductType(ordered, productTypes, 'AGRI');
    addProductType(ordered, productTypes, 'Sulfur');
    addProductType(ordered, productTypes, 'Other');
    ordered.push({
      productType: 'FAKE',
      label: 'FAKE',
      product: 0,
      packing: 0,
      shipment: 0,
      deliveryTerm: 0,
      port: 0,
      total: [],
    });

    const tdStyle = { display: 'none' };
    const options = {
      expandBy: 'column',
      expanding: productTypes.map(p => p.label),
    };
    const prodArray = [];
    for (let i = 0; i < productGroups.length; i++) {
      prodArray.push(this.productCheckbox(productGroups[i]));
    }
    return (
      <MainComponentBox>
        {this.accessDeniedAlert(this.state.showAlert)}
        {this.renderAvgValuesArea()}
        <Row>
          <Col xs={12} className="sticky-header position-book-header">
            <Row>
              <Col
                md={10}
                style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}
              >
                <span
                  className={'position-book-filter position-book-date'}
                >
                  {moment(new Date()).format('DD MMMM YYYY')}
                </span>
                {prodArray}
              </Col>
              <Col md={2} style={{ paddingTop: 3 }}>
                <Button
                  bsStyle="link"
                  title="Export to excel"
                  style={{ marginLeft: '20px', fontSize: '1.4em', padding: '0 5px',
                    float: 'right' }}
                  onClick={() => {
                    window.location =
                    `/api/report/export/positionbook?format=xlsx&productGroups=${this.props.productTypes.toJS()}`;  //eslint-disable-line
                  }}
                ><img src={xlsgrey} alt={'Export to excel'} className={'export-icon'} /></Button>
                <Button
                  bsStyle="link"
                  title="Export to pdf"
                  style={{ marginLeft: '20px', fontSize: '1.4em', padding: '0 5px',
                    float: 'right' }}
                  onClick={() => {
                    window.location =
                    `/api/report/export/positionbook?format=pdf&productGroups=${this.props.productTypes.toJS()}`;  //eslint-disable-line
                  }}
                ><img src={pdfgrey} alt={'Export to excel'} className={'export-icon'} /></Button>
              </Col>
            </Row>
          </Col>
          {this.props.done ?
            <div>
              <BootstrapTable
                expandableRow={() => ordered.length}
                className="positionBook"
                expandComponent={this.expandComponent}
                options={options}
                data={ordered}
                striped
              >
                <TableHeaderColumn
                  row="1"
                  isKey
                  dataField="label"
                  width={columnWidths.avgLS}
                  thStyle={{ width: columnWidths.avgLS, ...thMainStyle }}
                  columnClassName={this.headerClassName}
                  tdAttr={{ colSpan: '14' }}
                >
                  <Checkbox checked={this.hasChecked()} onChange={this.props.allCheckState} />
                </TableHeaderColumn>
                <TableHeaderColumn
                  row="1"
                  dataSort
                  dataField="sellerBuyer"
                  width={columnWidths.sellerBuyer}
                  sortFunc={this.sortFunc}
                  thStyle={{ width: columnWidths.sellerBuyer, ...thMainStyle }}
                  tdStyle={tdStyle}
                >
                Seller/Buyer
                </TableHeaderColumn>
                <TableHeaderColumn
                  row="1"
                  dataSort
                  dataField="contractNumber"
                  width={columnWidths.contractNumber}
                  sortFunc={this.sortFunc}
                  thStyle={{ width: columnWidths.contractNumber, ...thMainStyle }}
                  tdStyle={tdStyle}
                >
                  Contract number
                </TableHeaderColumn>
                <TableHeaderColumn
                  row="1"
                  dataField="product"
                  dataSort
                  width={columnWidths.product}
                  sortFunc={this.sortFunc}
                  thStyle={{ width: columnWidths.product, ...thMainStyle }}
                  tdStyle={tdStyle}
                >
                Product
                </TableHeaderColumn>
                <TableHeaderColumn
                  row="1"
                  dataSort
                  width={columnWidths.packing}
                  dataField="packing"
                  sortFunc={this.sortFunc}
                  thStyle={{ width: columnWidths.packing, ...thMainStyle }}
                  tdStyle={tdStyle}
                >
                Packing
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataSort
                  dataField="shipment"
                  sortFunc={this.sortFunc}
                  row="1"
                  width={columnWidths.shipment}
                  thStyle={{ width: columnWidths.shipment, ...thMainStyle }}
                  tdStyle={tdStyle}
                >
                Shipment
                </TableHeaderColumn>
                <TableHeaderColumn
                  row="1"
                  width={columnWidths.mts}
                  thStyle={{ width: columnWidths.mts, ...thMainStyle }}
                  tdStyle={tdStyle}
                >
                  <span style={{ color: 'var(--position-book-long)' }}>Long</span>/
                  <span style={{ color: 'var(--position-book-short)' }}>Short</span>
                </TableHeaderColumn>
                <TableHeaderColumn
                  row="1"
                  width={columnWidths.priceDollar}
                  thStyle={{ width: columnWidths.priceDollar, ...thMainStyle }}
                  tdStyle={tdStyle}
                >
                Price
                </TableHeaderColumn>
                <TableHeaderColumn
                  row="1"
                  dataField="deliveryTerm"
                  dataSort
                  width={columnWidths.deliveryTerm}
                  sortFunc={this.sortFunc}
                  thStyle={{ width: columnWidths.deliveryTerm, ...thMainStyle }}
                  tdStyle={tdStyle}
                >
                Delivery term
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataSort
                  row="1"
                  dataField="port"
                  sortFunc={this.sortFunc}
                  width={columnWidths.port}
                  thStyle={{ width: columnWidths.port, ...thMainStyle }}
                  tdStyle={tdStyle}
                >
                Port
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataSort
                  row="1"
                  dataField="fobNetBack"
                  sortFunc={this.sortFunc}
                  width={columnWidths.fobNetBack}
                  thStyle={{ width: columnWidths.fobNetBack, ...thMainStyle }}
                  tdStyle={tdStyle}
                >
                Netback
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataSort
                  row="1"
                  dataField="origin"
                  width={columnWidths.origin}
                  sortFunc={this.sortFunc}
                  thStyle={{ width: columnWidths.origin, ...thMainStyle }}
                  tdStyle={tdStyle}
                >
                Origin
                </TableHeaderColumn>
                <TableHeaderColumn
                  row="1"
                  width={columnWidths.colA}
                  thStyle={{ width: columnWidths.colA, ...thMainStyle }}
                  tdStyle={tdStyle}
                >
                M2M price
                </TableHeaderColumn>
                <TableHeaderColumn
                  row="1"
                  width={columnWidths.colB}
                  thStyle={{ width: columnWidths.colB, ...thMainStyle }}
                  tdStyle={tdStyle}
                >
                M2M delta
                </TableHeaderColumn>
                <TableHeaderColumn
                  row="1"
                  width={columnWidths.colC}
                  thStyle={{ width: columnWidths.colC, ...thMainStyle }}
                  tdStyle={tdStyle}
                >
                M2M P/L
                </TableHeaderColumn>
              </BootstrapTable>


              <BootstrapTable
                headerStyle={tdStyle}
                className="position-book-total"
                data={this.positionBookTotal(productTypes)}
                bordered={false}
              >
                <TableHeaderColumn
                  dataField="id"
                  isKey
                  hidden
                />
                <TableHeaderColumn
                  width={columnWidths.avgLS}
                />
                <TableHeaderColumn
                  width={columnWidths.sellerBuyer}
                />
                <TableHeaderColumn
                  width={columnWidths.contractNumber}
                />
                <TableHeaderColumn
                  width={columnWidths.product}
                />
                <TableHeaderColumn
                  width={columnWidths.packing}
                />
                <TableHeaderColumn
                  dataField="shipment"
                  width={columnWidths.shipment}
                />
                <TableHeaderColumn
                  width={columnWidths.mts}
                />
                <TableHeaderColumn
                  width={columnWidths.priceDollar}
                />
                <TableHeaderColumn
                  width={columnWidths.deliveryTerm}
                />
                <TableHeaderColumn
                  width={columnWidths.port}
                />
                <TableHeaderColumn
                  width={columnWidths.fobNetBack}
                />
                <TableHeaderColumn
                  width={columnWidths.origin}
                />
                <TableHeaderColumn
                  width={columnWidths.colA}
                />
                <TableHeaderColumn
                  dataField="diffM2M"
                  columnClassName={this.m2mClassName}
                  dataFormat={this.currencyFormatter}
                  width={columnWidths.colB}
                />
                <TableHeaderColumn
                  dataField="M2MPL"
                  columnClassName={this.m2mClassName}
                  dataFormat={this.currencyFormatter}
                  width={columnWidths.colC}
                />
              </BootstrapTable>
            </div>
            :
            <div />
          }
        </Row>
      </MainComponentBox>
    );
  }
}

// eslint-disable-next-line
class ProductGroupListClass extends React.Component {

  constructor(props) {
    super(props);
    this.init = this.init.bind(this);
    this.portRowFormatter = this.portRowFormatter.bind(this);
    this.productFormatter = this.productFormatter.bind(this);
    this.m2mPriceFormatter = this.m2mPriceFormatter.bind(this);
    this.fobOriginFormatter = this.fobOriginFormatter.bind(this);
    this.state = { showTooltip: false, colA: null, data: [] };
  }

  componentWillMount() {
    this.init();
  }

  componentWillReceiveProps(props) {
    this.init(props);
  }

  formatPrice(compositeProduct) {
    if (compositeProduct.fixedPrice || compositeProduct.fixedPrice === null) {
      const price = getCurrencyValue(compositeProduct);
      return price == 0 && compositeProduct.overridenPrice !== 0 ?
        'N/A' : `$ ${formatNumber(price, '0,0.[00]') || 0}`;
    }
    return 'formula';
  }

  formatQuantityRange(dto) {
    const unlinkedMin = dto.unlinkedMin || dto.compositeProduct.quantityMin;
    const unlinkedMax = dto.unlinkedMax || dto.compositeProduct.quantityMax;

    if (unlinkedMin == unlinkedMax) {
      return formatQuantityNumber(unlinkedMin);
    }
    return `${formatQuantityNumber(unlinkedMin)}
       - ${formatQuantityNumber(unlinkedMax)}`;
  }

  minMts(dto) {
    return dto.unlinkedMin || dto.compositeProduct.quantityMin;
  }

  formatShipment(compositeProduct) {
    const shipmentFrom = compositeProduct.shipmentFrom;
    const shipmentTo = compositeProduct.shipmentTo;

    const range = formatRange(shipmentFrom, shipmentTo) || '';
    if (shipmentFrom && shipmentTo) {
      if (moment(shipmentFrom, 'DD MMM YYYY').format('YYYY') ==
        moment(shipmentTo, 'DD MMM YYYY').format('YYYY')) {
        return range.length > 4 ? range.slice(0, range.length - 4) : range;
      }
    }
    return range;
  }

  totalRowFormatter(value, row) {
    if (row.isTotalRow && (row.weight == 5 || row.weight == 6)) {
      return (<b
        style={{ color: row.dealType == 'purchase'
          ? 'var(--position-book-long)' : 'var(--position-book-short)' }}
      >
        {value}
      </b>);
    }
    return (<span
      style={{ color: row.dealType == 'purchase'
        ? 'var(--position-book-long)' : 'var(--position-book-short)' }}
    >
      {value}
    </span>);
  }

  diffPriceFormatter(value, row) {
    let result = '';
    if (row.isTotalRow && row.totalM2MDelta) {
      result = `$ ${formatNumber(row.totalM2MDelta, '0,0.00')}`;
    } else {
      const marketPrice = row.marketPrice || row.externalM2M;
      if (row.isTotalRow || !marketPrice || !row.priceValue) {
        return '';
      }
      result = `$ ${formatNumber(row.diffPrice, '0,0.00')}`;
    }
    return (
      <div
        title={result}
      >
        {result}
      </div>
    );
  }

  actualPriceClassName(fieldValue, row) {
    const marketPrice = row.marketPrice || row.externalM2M || row.totalM2MPL || 0;
    const green = 'td-pb-actualPrice-green';
    const red = 'td-pb-actualPrice-red';

    const m2mPrice = row.totalM2MPL || getM2MPL(row);
    if (row.priceValue || row.isTotalRow) {
      if (marketPrice && m2mPrice > 0) {
        return green;
      } else if (marketPrice && m2mPrice < 0) {
        return red;
      }
    }
    return '';
  }

  actualPriceFormatter(value, row) {
    let result = '';
    if (row.isTotalRow && row.totalM2MPL) {
      result = `$ ${formatNumber(row.totalM2MPL, '0,0')}`;
    } else {
      const marketPrice = row.marketPrice || row.externalM2M;
      if (row.isTotalRow || !marketPrice || !row.priceValue) {
        return '';
      }
      result = `$ ${formatNumber(getM2MPL(row), '0,0')}`;
    }
    return (
      <div title={result}>
        {result}
      </div>
    );
  }

  fobOriginFormatter(value, row) {
    if (row.fobNetBackOriginal) {
      return (<div>
        <span title={value} style={{display: 'inline-block'}}>{value}</span>
        <Button
          id="editFobPortButton"
          bsStyle="link"
          className="btn-link-no-underline-on-hover"
          onClick={() => this.setState({
            portToEdit: this.state.portToEdit == row.productId ? null : row.productId,
          })}
          style={{ padding: 0, width: '30px', textAlign: 'center', float: 'right' }}
        >
          <img
            src={pencil} alt={'edit'} title={'edit'} className={'payments-table-small-icon'}
          />
        </Button>
        {(row.fobPort || row.fobPort === 0 || this.state.portToEdit == row.productId) && <div
          className="fob-port-select"
        >
          <RefPicker
            dict="port"
            name="fobPort"
            disabled={this.state.portToEdit != row.productId}
            defaultValue={row.fobPort}
            onChangeFunc={v => {
              this.props.updateFobPort(row.productId, row.dealId, v ? v.value : '');
              this.setState({ portToEdit: null });
            }}
          />
        </div>
        }
      </div>);
    }
    return value;
  }

  m2mPriceFormatter(value, row) {
    if (row.isTotalRow && row.weight > 0) {
      return '';
    }
    const viewMode = row.fixedPrice && this.props.selectedProductId != row.productId;
    let buttonFunc = () => {
      this.setState({ marketPrice: row.marketPrice || 0 });
      return this.props.editProduct && this.props.editProduct(row.dealType, row.productId);
    };
    if (!viewMode) {
      buttonFunc = () => {
        this.props.updateDealMarkerPrice(row.dealType, row.dealId,
          row.productId, this.state.marketPrice);
        this.setState({ marketPrice: null });
      };
    }
    const tooltipStyle = { visibility: row.marketPriceDate ? 'visible' : 'hidden' };
    const disabled = this.props.selectedProductId != row.productId || this.props.disabled;

    const textProps = {
      className: 'form-control customColor',
      currency: formatCurrency('USD'),
      style: {
        textAlign: 'right',
        height: '24px',
        color: (row.dealType === 'purchase') ?
          purchaseColumn.color : saleColumn.color,
      },
      fraction: 2,
      positive: true,
      negative: false,
      thousand: true,
      type: 'number',
    };
    const showValue = (row.priceValue && row.fixedPrice) || row.externalM2M;
    return (
      <div
        style={{
          display: showValue ? 'flex' : 'none',
          color: (row.dealType === 'purchase') ? purchaseColumn.color : saleColumn.color,
        }}
      >
        <OverlayTrigger
          placement="top"
          overlay={row.marketPrice ?
            <Tooltip id={row.id} style={tooltipStyle}>{row.marketPriceDate}</Tooltip>
            : <span id={row.id} />}
        >
          <div
            style={{
              display: showValue ? 'flex' : 'none',
              color: (row.dealType === 'purchase') ? purchaseColumn.color : saleColumn.color,
              marginLeft: 'auto',
            }}
          >
            {!(disabled && !row.externalM2M && !row.marketPrice) && <div>

              {disabled ?
                <FancyInput
                  value={row.marketPrice || row.externalM2M}
                  disabled
                  {...textProps}
                />
                :
                <FancyInput
                  value={row.marketPrice}
                  disabled={disabled}
                  onChange={(e, val) => this.setState({ marketPrice: val })}
                  {...textProps}
                />
              }
            </div>
            }
            <Button
              id="editSaveButton"
              bsStyle="link"
              disabled={this.props.disabled}
              className={'btn-link-no-underline-on-hover'}
              onClick={buttonFunc}
              style={{padding: 0, textAlign: 'center', visibility: row.priceValue && row.fixedPrice ? 'visible': 'hidden'}}
            >
              <img
                src={row.marketPrice ? pencilred : pencil} alt={'edit'} title={'edit'}
                className={'payments-table-small-icon'}
              />
            </Button>
          </div>
        </OverlayTrigger>
      </div>
    );
  }

  portRowFormatter(value, row, extraData, rowIdx) {
    return (
      <div
        style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflowX: 'hidden' }}
        id={`port${row.productId}${rowIdx}`}
        title={value}
      >{value}</div>
    );
  }

  shipmentRowFormatter(value, row) {
    if (row.isTotalRow && (row.weight == 5 || row.weight == 6)) {
      return <b>{value}</b>;
    }
    return value;
  }

  init(props = this.props) {
    const data = props.data.concat(props.totalData).toJS();
    this.setState({
      data: data.map((d) => {
        if (d.isTotalRow) {
          return d;
        }

        /* eslint-disable*/
        d.compositeProduct.originalPrice = d.compositeProduct.priceValue;
        if (d.overridenPrice || d.overridenPrice === 0) {
          d.compositeProduct.priceValue = d.overridenPrice;
          d.compositeProduct.overridenPrice = d.overridenPrice;
          d.compositeProduct.priceCurrency = Currency.DOLLAR;
        }
        const isDTOverriden = d.overridenDT !== undefined && d.overridenDT !== null;
        /* eslint-enable */
        const ports = d.overridenPort || d.compositeProduct.ports;
        return {
          sellerBuyer: props.buyer.find(b => b.get('id') == d.sellerBuyer, this,
            props.seller.find(s => s.get('id') == d.sellerBuyer, this, new Map())).get('name'),
          product: productNameResolver(d.compositeProduct),
          contractNumber: d.contractNumber,
          packing: `${props.packing.find(p =>
            p.get('id') === d.compositeProduct.packing, this, new Map()).get('name') || ''}${
            d.transportName ? `, ${d.transportName}` : ''}`,
          shipment: this.formatShipment(d.compositeProduct),
          shipmentFrom: d.compositeProduct.shipmentFrom,
          shipmentTo: d.compositeProduct.shipmentTo,
          deliveryTerm: (props.deliveryTerm.find(dt =>
            dt.get('id') == (isDTOverriden ? d.overridenDT
              : d.compositeProduct.deliveryTerm), this, new Map()).get('name') || '')
            + (isDTOverriden ? '*' : ''),
          port: ports ?
            ports.map(port => props.port.find(dt =>
              dt.get('id') == port, this, new Map()).get('name')).join(', ') : '',
          mts: this.formatQuantityRange(d),
          mtsMin: this.minMts(d),
          mtsNatural: formatQuantityRangeNatural(d),
          priceDollar: this.formatPrice(d.compositeProduct),
          purchaseDate: d.purchaseDate,
          saleDate: d.saleDate,
          creationTime: d.creationTime,
          dealId: d.dealId,
          dealType: d.dealType,
          priceCurrency: d.compositeProduct.priceCurrency,
          priceCurrencyRates: d.compositeProduct.priceCurrencyRates,
          productId: d.compositeProduct.id,
          fixedPrice: d.compositeProduct.fixedPrice || d.compositeProduct.fixedPrice === null,
          priceValue: d.compositeProduct.priceValue,
          marketPrice: d.compositeProduct.marketPrice,
          marketPriceDate: d.compositeProduct.marketPriceDate,
          avgQuantity: avgQuantity(d.compositeProduct),
          fobNetBackOriginal: d.fobNetBackOriginal,
          fobNetBack: d.fobNetBack,
          origin: d.origin,
          diffPrice: getM2MDiff(d),
          externalM2M: d.externalM2M,
          fobPort: d.compositeProduct.fobPort,
          idx: d.idx,
          checkState: d.checkState,
        };
      }),
    });
  }

  columnClassNameFormat(fieldValue, row) {
    if (row.isTotalRow) {
      return 'alignRight';
    }
    return '';
  }

  productFormatter(value, row) {
    return (
      <Button
        bsStyle="link"
        style={{
          fontSize: '12px', padding: 0, whiteSpace: 'nowrap',
          textOverflow: 'ellipsis', overflowX: 'hidden', textAlign: 'left',
        }}
        onClick={() => {
          if (validateRoleConfig(['myDeals#1', 'allDeals#1'],
            this.props[`${row.dealType}s`].find(deal => deal.get('id') === row.dealId))) {
            this.props.go(`/deals/${row.dealType}/${row.dealId}?fromTab=positionbook`);
          } else {
            this.props.showAlert();
          }
        }}
        title={value}
      >
        {value}
      </Button>
    );
  }

  tableSort(a, b, order) {
    return numberSort('weight', a, b, 'asc') || sortSimpleText(a, b, order, 'dealType')
      || contractDateSort(a, b) || dealSumSort(a, b) || sortSimpleText(a, b, order, 'product');
  }

  sellerBuyerSort(a, b, order) {
    return groupDeals(a, b) || numberSort('weight', a, b, 'asc')
      || sortSimpleText(a, b, order, 'sellerBuyer')
      || sortSimpleText(a, b, order, 'product') || sortSimpleText(a, b, order, 'packing')
      || sortDate('shipmentFrom', a, b, order) || sortDate('shipmentTo', a, b, order)
      || sortSimpleText(a, b, order, 'deliveryTerm') || sortSimpleText(a, b, order, 'port');
  }

  productSort(a, b, order) {
    return groupDeals(a, b) || numberSort('weight', a, b, 'asc')
      || sortSimpleText(a, b, order, 'product')
      || sortSimpleText(a, b, order, 'sellerBuyer')
      || sortSimpleText(a, b, order, 'packing')
      || sortDate('shipmentFrom', a, b, order) || sortDate('shipmentTo', a, b, order)
      || sortSimpleText(a, b, order, 'deliveryTerm') || sortSimpleText(a, b, order, 'port');
  }

  packingSort(a, b, order) {
    return groupDeals(a, b) || numberSort('weight', a, b, 'asc')
      || sortSimpleText(a, b, order, 'packing')
      || sortDate('shipmentFrom', a, b, order) || sortDate('shipmentTo', a, b, order)
      || sortSimpleText(a, b, order, 'deliveryTerm') || sortSimpleText(a, b, order, 'port');
  }

  shipmentSort(a, b, order) {
    return groupDeals(a, b) || numberSort('weight', a, b, 'asc')
      || sortDate('shipmentFrom', a, b, order) || sortDate('shipmentTo', a, b, order)
      || sortSimpleText(a, b, order, 'deliveryTerm') || sortSimpleText(a, b, order, 'port');
  }

  dtSort(a, b, order) {
    return groupDeals(a, b) || numberSort('weight', a, b, 'asc')
      || sortSimpleText(a, b, order, 'deliveryTerm') || sortSimpleText(a, b, order, 'port');
  }

  netbackSort(a, b, order) {
    return groupDeals(a, b)
      || numberSort('weight', a, b, 'asc')
      || sortSimpleText(a, b, order, 'fobNetBack');
  }

  portSort(a, b, order) {
    const preSort = groupDeals(a, b) || numberSort('weight', a, b, 'asc');
    if (preSort) {
      return preSort;
    }
    const moveCountryToBegining = (text) => {
      if (typeof text == 'string') {
        const textArray = text.split(',');
        const country = textArray.pop();
        textArray.unshift(country);
        return textArray.join();
      }
      return text;
    };

    if (a == b) {
      return 0;
    }
    const aLc = (a && a.port || '').toLowerCase();
    const bLc = (b && b.port || '').toLowerCase();
    if (aLc == bLc) {
      return 0;
    }

    return so(moveCountryToBegining(aLc) > moveCountryToBegining(bLc) ? 1 : -1, order);
  }

  originSort(a, b, order) {
    return groupDeals(a, b)
      || numberSort('weight', a, b, 'asc') || sortSimpleText(a, b, order, 'origin');
  }

  avgCalcFormatter = (value, row) => {
    if (row.isTotalRow) {
      return '';
    }
    return (
      <div>
        <Checkbox
          style={{ margin: 0, top: 4, left: -2 }}
          checked={value}
          onChange={(e) => {
            this.props.updateCheckState(row.idx, e.target.checked);
          }}
        />
      </div>
    );
  };

  rowClassName = (row) => (`${row.isTotalRow && 'position-book-total-row'
  } ${row.isGrandTotalRow && 'position-book-grand-total-row'}`);

  render() {
    const tdStyle = { whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflowX: 'hidden' };
    const options = {
      defaultSortName: 'product',
      defaultSortOrder: 'asc',
    };
    return (
      <BootstrapTable
        headerStyle={{ display: 'none' }}
        options={options}
        ref="table"
        className="positionBookSub"
        data={this.state.data}
        striped
        trClassName={this.rowClassName}
      >
        <TableHeaderColumn
          dataField="id"
          isKey
          hidden
        />
        <TableHeaderColumn
          dataField="dealType"
          dataSort
          hidden
          sortFunc={this.tableSort}
          tdStyle={{ display: 'none' }}
        />
        <TableHeaderColumn
          dataField="checkState"
          width={columnWidths.avgLS}
          dataSort
          tdStyle={{ ...tdStyle, width: columnWidths.avgLS }}
          dataFormat={this.avgCalcFormatter}
        />
        <TableHeaderColumn
          width={columnWidths.sellerBuyer}
          dataField="sellerBuyer"
          dataSort
          columnTitle
          sortFunc={this.sellerBuyerSort}
          tdStyle={{ ...tdStyle, width: columnWidths.sellerBuyer }}
        >
          Seller/Buyer
        </TableHeaderColumn>
        <TableHeaderColumn
          width={columnWidths.contractNumber}
          dataField="contractNumber"
          dataSort
          columnTitle
          tdStyle={{ ...tdStyle, width: columnWidths.contractNumber }}
        >
          Contract number
        </TableHeaderColumn>
        <TableHeaderColumn
          width={columnWidths.product}
          tdStyle={{ ...tdStyle, width: columnWidths.product }}
          dataField="product"
          sortFunc={this.productSort}
          dataFormat={this.productFormatter}
        >
          Product
        </TableHeaderColumn>
        <TableHeaderColumn
          columnTitle
          width={columnWidths.packing}
          dataField="packing"
          dataSort
          sortFunc={this.packingSort}
          tdStyle={{ ...tdStyle, whiteSpace: 'normal', width: columnWidths.packing }}
        >
          Packing
        </TableHeaderColumn>
        <TableHeaderColumn
          columnTitle
          width={columnWidths.shipment}
          sortFunc={this.shipmentSort}
          tdStyle={{ ...tdStyle, width: columnWidths.shipment }}
          dataField="shipment"
          dataFormat={this.shipmentRowFormatter}
        >
          Shipment
        </TableHeaderColumn>
        <TableHeaderColumn
          width={columnWidths.mts}
          tdStyle={{ ...tdStyle, width: columnWidths.mts }}
          dataField="mts"
          dataFormat={this.totalRowFormatter}
        >
          <span style={{ color: 'var(--position-book-long)' }}>Long</span>/
          <span style={{ color: 'var(--position-book-short)' }}>Short</span>
        </TableHeaderColumn>
        <TableHeaderColumn
          width={columnWidths.priceDollar}
          tdStyle={{ ...tdStyle, width: columnWidths.priceDollar }}
          dataField="priceDollar"
          dataFormat={this.totalRowFormatter}
        >
          Price
        </TableHeaderColumn>
        <TableHeaderColumn
          columnTitle
          width={columnWidths.deliveryTerm}
          sortFunc={this.dtSort}
          thStyle={thMainStyle}
          tdStyle={{ ...tdStyle, width: columnWidths.deliveryTerm }}
          dataField="deliveryTerm"
        >
          Delivery term
        </TableHeaderColumn>
        <TableHeaderColumn
          width={columnWidths.port}
          sortFunc={this.portSort}
          dataField="port"
          tdStyle={{ width: columnWidths.port }}
          dataFormat={this.portRowFormatter}
          columnClassName={this.columnClassNameFormat}
        >
          Port
        </TableHeaderColumn>
        <TableHeaderColumn
          columnTitle
          width={columnWidths.fobNetBack}
          dataField="fobNetBack"
          sortFunc={this.netbackSort}
          tdStyle={{ width: columnWidths.fobNetBack }}
          columnClassName={this.columnClassNameFormat}
        >
          Netback
        </TableHeaderColumn>
        <TableHeaderColumn
          width={columnWidths.origin}
          sortFunc={this.originSort}
          dataField="origin"
          tdStyle={{ width: columnWidths.origin, overflow: 'inherit', padding: '5px 3px' }}
          columnClassName={this.columnClassNameFormat}
          dataFormat={this.fobOriginFormatter}
        >
          Origin
        </TableHeaderColumn>
        <TableHeaderColumn
          width={columnWidths.colA}
          tdStyle={{ ...tdStyle, width: columnWidths.colA, padding: '5px 3px' }}
          dataFormat={this.m2mPriceFormatter}
        >
          ColA
        </TableHeaderColumn>
        <TableHeaderColumn
          width={columnWidths.colB}
          tdStyle={{ ...tdStyle, width: columnWidths.colB }}
          columnClassName={this.actualPriceClassName}
          dataFormat={this.diffPriceFormatter}
        >
          ColB
        </TableHeaderColumn>
        <TableHeaderColumn
          width={columnWidths.colC}
          tdStyle={{ ...tdStyle, width: columnWidths.colC }}
          columnClassName={this.actualPriceClassName}
          dataFormat={this.actualPriceFormatter}
        >
          ColC
        </TableHeaderColumn>
      </BootstrapTable>
    );
  }
}

ProductGroupListClass.propTypes = {
  buyer: React.PropTypes.object.isRequired,
  seller: React.PropTypes.object.isRequired,
  packing: React.PropTypes.object.isRequired,
  deliveryTerm: React.PropTypes.object.isRequired,
  port: React.PropTypes.object.isRequired,
  products: React.PropTypes.object.isRequired,
  editProduct: React.PropTypes.func,
  selectedProductId: React.PropTypes.number,
  updateDealMarkerPrice: React.PropTypes.func.isRequired,
  disabled: React.PropTypes.bool,
  go: React.PropTypes.func.isRequired,
  showAlert: React.PropTypes.func.isRequired,
  updateFobPort: React.PropTypes.func,
  updateCheckState: React.PropTypes.func.isRequired,
};

const ProductGroupList = connect(
  state => ({
    seller: state.getIn(['references', 'simple', 'buyer'], new List()),
    buyer: state.getIn(['references', 'simple', 'supplier'], new List()),
    packing: state.getIn(['references', 'simple', 'packing'], new List()),
    deliveryTerm: state.getIn(['references', 'simple', 'deliveryterm'], new List()),
    port: state.getIn(['references', 'simple', 'port'], new List()),
  }),
  (dispatch) => ({
    go(url) {
      navTo(url);
    },
    updateFobPort(productId, dealId, portId) {
      updateFobPort(dispatch, productId, dealId, portId);
    },
    updateCheckState(idx, checkState) {
      updateCheckStateDispatch(dispatch, idx, checkState);
    },
  }), null, { withRef: true })(ProductGroupListClass);

PositionBook.propTypes = {
  data: React.PropTypes.object.isRequired,
  purchases: React.PropTypes.object.isRequired,
  sales: React.PropTypes.object.isRequired,
  done: React.PropTypes.bool,
  loading: React.PropTypes.bool,
  generateReport: React.PropTypes.func.isRequired,
  clearPositionBook: React.PropTypes.func.isRequired,
  productTypes: React.PropTypes.object.isRequired,
  updateProductTypes: React.PropTypes.func.isRequired,
  updateDealMarketPrice: React.PropTypes.func.isRequired,
  selectProduct: React.PropTypes.func.isRequired,
  selectedProductId: React.PropTypes.number,
  selectedDealType: React.PropTypes.number,
  saving: React.PropTypes.bool,
  allCheckState: React.PropTypes.func.isRequired,
  products: React.PropTypes.object.isRequired,
};

export default connect(
  state => ({
    data: state.getIn(['data', 'reports', 'positionBook', 'data'], new Map()),
    done: state.getIn(['data', 'reports', 'positionBook', 'done'], false),
    loading: state.getIn(['data', 'reports', 'positionBook', 'loading'], false),
    productTypes: state.getIn(['data', 'reports', 'positionBook', 'productTypes'], new List()),
    selectedProductId: state.getIn(['data', 'reports', 'positionBook', 'productId']),
    selectedDealType: state.getIn(['data', 'reports', 'positionBook', 'dealType']),
    saving: state.getIn(['allaround', 'saving'], false),
    purchases: state.getIn(['data', 'deals', 'list', 'purchase'], new List()),
    sales: state.getIn(['data', 'deals', 'list', 'sale'], new List()),
    products: state.getIn(['references', 'complex', 'product'], new List()),
  }),
  dispatch => ({
    generateReport(pg) {
      generateReport(dispatch, pg);
    },
    clearPositionBook() {
      clearPositionBookReport(dispatch);
    },
    updateProductTypes(productTypes, pt, addRemove) {
      let newProductTypes = productTypes.filter(p => p !== pt);
      if (addRemove) {
        newProductTypes = newProductTypes.push(pt);
      }
      updateProductTypes(dispatch, newProductTypes);
    },
    updateDealMarketPrice(type, id, productId, marketPrice) {
      updateDealMarketPrice(dispatch, type, id, productId, marketPrice);
    },
    selectProduct(dealType, productId) {
      selectProduct(dispatch, dealType, productId);
    },
    allCheckState(e) {
      allCheckStateDispatch(dispatch, e.target.checked);
    },
  }),
)(PositionBook);
